import React from 'react';

export const renderExtra = (elements: JSX.Element[], direction: 'prev' | 'next') => {
  let output: JSX.Element[] = [];
  const length = elements?.length ?? 0;
  if (!length) return [];
  for (let index = 0; index < length; index += 1) {
    let extraItem = <></>;
    if (direction === 'next' && elements?.[index]) {
      extraItem = React.cloneElement(elements[index], { withoutAnalytics: true });
    }
    if (direction === 'prev' && elements?.[length - 1 - index]) {
      extraItem = React.cloneElement(elements[length - 1 - index], { withoutAnalytics: true });
    }
    output.push(extraItem);
  }
  if (direction === 'prev') output.reverse();
  return output;
};
